export default __webpack_public_path__ + "static/media/welcomeMessage.e1835a10.svg";